import { Box } from '@lounge-fe/ui-kit'
import { DiscountModalTriggerProps } from './types'
import { useDiscountModalStore } from './store'

export const DiscountModalTrigger = ({
  as,
  children,
  className,
}: DiscountModalTriggerProps) => {
  const { open } = useDiscountModalStore()

  return (
    <Box as={as} onClick={open} className={className}>
      {children}
    </Box>
  )
}
